// Libs
import { differenceInCalendarDays, subDays } from 'date-fns';
import type { DateRange } from 'ui-components';
// App
import { OrderStatisticsFilters } from 'app-shared/lib/api/shop-administration/order/statistics';

export const countPeriodDays = (startDate: Date, endDate: Date): number => {
  const numberOfDays = differenceInCalendarDays(endDate, startDate) + 1;

  return numberOfDays;
};

export const buildCustomPeriodQueryParams = (customPeriod: DateRange): OrderStatisticsFilters => {
  const queryParams: OrderStatisticsFilters = {
    startDate: customPeriod.start,
    endDate: customPeriod.end,
  };

  return queryParams;
};

export const buildPreviousCustomPeriodQueryParams = (customPeriod: DateRange): OrderStatisticsFilters => {
  const { start, end } = customPeriod;
  const numberOfDays = countPeriodDays(start, end);

  const queryParams: OrderStatisticsFilters = {
    startDate: subDays(start, numberOfDays),
    endDate: subDays(end, numberOfDays),
  };

  return queryParams;
};
